import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box, Chip, Dialog, DialogTitle, IconButton } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { Attendance_Service } from "../../services/attendance/attendance-service";
import { RUDTable } from "../Table/RUDTable";
import UserContext, { User_Type } from "../UserContext";
import { dateFormatter } from "../constants";

const SingleAttendanceHistory = ({ row, type }: any) => {
    console.log(row, "row in single attendance history");
    const [open, setOpen] = useState(false);
    const [data, setData] = useState<any>();
    const [filter, set_filter] = useState<any>();
    const { user } = useContext(UserContext);

    useEffect(() => {
        const startDate = row?.CheckIn
            ? row.CheckIn.split(" ")[0]
            : row?.CheckOut
              ? row.CheckOut.split(" ")[0]
              : null;

        console.log(startDate);

        const endDate = row?.CheckOut
            ? row.CheckOut.split(" ")[0]
            : row?.CheckIn
              ? row.CheckIn.split(" ")[0]
              : null;

        console.log(endDate);
        if (user?.user_type === User_Type.Admin) {
            set_filter((f: any) => ({
                ...f,
                organizationCode: user.organization.code,
                apiKey: user.organization.apiKey[0].key,
                startDate: startDate,
                endDate: endDate,
                pin: row,
            }));
        }
    }, [user?.user_type]);

    return (
        <Box maxWidth="lg">
            <IconButton
                onClick={() => setOpen(true)}
                size="small"
                style={{ display: "flex", justifyContent: "center" }}
            >
                <VisibilityIcon fontSize="small" />
            </IconButton>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                maxWidth="lg"
                fullWidth
            >
                <DialogTitle>Attendance History</DialogTitle>
                <RUDTable
                    readables={{
                        name: "Name",
                        pin: "Pin",
                        timestamp: "Date",
                        attendanceStatus: "Status",
                    }}
                    rowsPreprocessor={(row) => {
                        console.log(row.timestamp, "timestamp");
                        return {
                            ...row,
                            name: row?.user?.name,
                            timestamp: dateFormatter.format(
                                new Date(row.timestamp)
                            ),
                            pin: row?.user?.pin,
                            branch: row?.branch?.name,
                            attendanceStatus:
                                row.status === 0 ? (
                                    <Chip color="success" label="Check In" />
                                ) : row.status === 1 ? (
                                    <Chip color="error" label="Check Out" />
                                ) : row.status === 2 ? (
                                    <Chip color="warning" label="Break Out" />
                                ) : row.status === 3 ? (
                                    <Chip color="info" label="Break In" />
                                ) : row.status === 4 ? (
                                    <Chip color="primary" label="OT Check In" />
                                ) : row.status === 5 ? (
                                    <Chip
                                        color="secondary"
                                        label="OT Check Out"
                                    />
                                ) : (
                                    <Chip color="default" label="Unknown" />
                                ),
                        };
                    }}
                    getter={(page, limit) =>
                        Attendance_Service.get_attendanceByDay(
                            {
                                page,
                                limit,
                                filter: {
                                    startDate:
                                        type == "singleUserAttendance"
                                            ? row.date
                                            : row?.CheckIn
                                              ? row.CheckIn.split(" ")[0]
                                              : row?.CheckOut
                                                ? row.CheckOut.split(" ")[0]
                                                : null,
                                    endDate:
                                        type == "singleUserAttendance"
                                            ? row.date
                                            : row?.CheckOut
                                              ? row.CheckOut.split(" ")[0]
                                              : row?.CheckIn
                                                ? row.CheckIn.split(" ")[0]
                                                : null,
                                    user: row?.user_pin,
                                },
                            },
                            filter.apiKey,
                            filter.organizationCode
                        )
                    }
                    ops={{ read: "" }}
                    updatingAgents={[]}
                    storageKey="Attendance History Day Wise"
                />
            </Dialog>
        </Box>
    );
};

export default SingleAttendanceHistory;
